// Pagina demo HM-301: visualizza ogni token del design system v2.6.
// Routata in HM-307 a /dev/tokens (sezione interna admin).

const swatches = {
  Sfondi: [
    { name: 'bg-base', cls: 'bg-bg-base text-text-primary' },
    { name: 'bg-card', cls: 'bg-bg-card text-text-primary border border-border-base' },
    { name: 'bg-muted', cls: 'bg-bg-muted text-text-primary' },
    { name: 'bg-sidebar', cls: 'bg-bg-sidebar text-text-on-sidebar' },
    { name: 'bg-sidebar-hover', cls: 'bg-bg-sidebar-hover text-text-on-sidebar' },
    { name: 'bg-sidebar-active', cls: 'bg-bg-sidebar-active text-text-on-sidebar' },
    { name: 'bg-topbar', cls: 'bg-bg-topbar text-text-primary border border-border-base' },
  ],
  Accenti: [
    { name: 'accent-primary', cls: 'bg-accent-primary text-text-on-accent' },
    { name: 'accent-primary-hover', cls: 'bg-accent-primary-hover text-text-on-accent' },
    { name: 'accent-soft', cls: 'bg-accent-soft text-text-primary' },
    {
      name: 'accent-primary-text on white',
      cls: 'bg-bg-card text-accent-primary-text border border-border-base',
    },
  ],
  'Stati camere': [
    { name: 'state-lib', cls: 'bg-state-lib text-text-on-accent' },
    { name: 'state-ris', cls: 'bg-state-ris text-text-on-accent' },
    { name: 'state-occ', cls: 'bg-state-occ text-text-on-accent' },
    { name: 'state-sprc', cls: 'bg-state-sprc text-text-on-accent' },
    { name: 'state-guas', cls: 'bg-state-guas text-text-on-accent' },
    { name: 'state-puliz', cls: 'bg-state-puliz text-text-primary' },
  ],
  Ombre: [
    { name: 'shadow-hm-sm', cls: 'bg-bg-card text-text-primary shadow-hm-sm' },
    { name: 'shadow-hm-md', cls: 'bg-bg-card text-text-primary shadow-hm-md' },
    { name: 'shadow-hm-lg', cls: 'bg-bg-card text-text-primary shadow-hm-lg' },
    { name: 'shadow-hm-xl', cls: 'bg-bg-card text-text-primary shadow-hm-xl' },
  ],
};

export function TokensDemo() {
  return (
    <div className="min-h-screen bg-bg-base p-8">
      <h1 className="text-3xl font-bold text-text-primary mb-2 tracking-hm-tight">
        Design System Tokens — SPEC v2.6
      </h1>
      <p className="text-text-secondary mb-8">
        Palette warm boutique, light mode only (dark mode Fase 2).
      </p>
      {Object.entries(swatches).map(([group, items]) => (
        <section key={group} className="mb-10">
          <h2 className="text-xl font-semibold text-text-primary mb-4">{group}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((s) => (
              <div
                key={s.name}
                className={`${s.cls} rounded-lg p-6 h-24 flex items-end font-mono text-sm`}
              >
                {s.name}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
